import { computed, type Ref } from 'vue'
import type { IEvent } from '@/types'

/**
 * Composable pro výpočet statusu home/away týmu na match-tile.
 * Vrací resultString (např. "12+2") a color ('green' / 'eventFull').
 */
export function useMatchTeamStatus(eventRef: Ref<IEvent>) {
  const whiteTeamStatus = computed(() => {
    const ev = eventRef.value
    const totalPlayers =
      (ev.homeAttendants?.players?.length || 0) +
      (ev.homeInDeposit?.players?.length || 0)
    const totalGoalies =
      (ev.homeAttendants?.goalies?.length || 0) +
      (ev.homeInDeposit?.goalies?.length || 0)

    const threshold = ev.meta?.homePlayers ?? 15
    let color =
      totalPlayers >= threshold && (ev.meta?.homeGoalies ?? 0) >= 1
        ? 'green'
        : 'eventFull'

    const rosterComplete = (ev.roastedPlayers?.white?.length || 0) > 15
    if (rosterComplete) color = 'green'

    return { resultString: `${totalPlayers}+${totalGoalies}`, color, rosterComplete }
  })

  const blueTeamStatus = computed(() => {
    const ev = eventRef.value
    const totalPlayers =
      (ev.awayAttendants?.players?.length || 0) +
      (ev.awayInDeposit?.players?.length || 0)
    const totalGoalies =
      (ev.awayAttendants?.goalies?.length || 0) +
      (ev.awayInDeposit?.goalies?.length || 0)

    const threshold = ev.meta?.awayPlayers ?? 15
    let color =
      totalPlayers >= threshold && (ev.meta?.awayGoalies ?? 0) >= 1
        ? 'green'
        : 'eventFull'

    const rosterComplete = (ev.roastedPlayers?.blue?.length || 0) > 15
    if (rosterComplete) color = 'green'

    return { resultString: `${totalPlayers}+${totalGoalies}`, color, rosterComplete }
  })

  return { whiteTeamStatus, blueTeamStatus }
}
